import React, { createContext, useState, useContext, useEffect } from 'react';

const BusinessAuthContext = createContext(null);

export const useBusinessAuth = () => {
  const context = useContext(BusinessAuthContext);
  if (!context) {
    throw new Error('useBusinessAuth must be used within a BusinessAuthProvider');
  }
  return context;
};

export const BusinessAuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [daycare, setDaycare] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:10000';

  useEffect(() => {
    // Check for stored token on mount
    const storedToken = localStorage.getItem('barkbacks_business_token');
    const storedDaycare = localStorage.getItem('barkbacks_business_daycare');

    if (storedToken && storedDaycare) {
      setToken(storedToken);
      setDaycare(JSON.parse(storedDaycare));
    }

    setLoading(false);
  }, []);

  const login = (authToken, daycareData) => {
    setToken(authToken);
    setDaycare(daycareData);
    localStorage.setItem('barkbacks_business_token', authToken);
    localStorage.setItem('barkbacks_business_daycare', JSON.stringify(daycareData));
  };

  const logout = () => {
    setToken(null);
    setDaycare(null);
    localStorage.removeItem('barkbacks_business_token');
    localStorage.removeItem('barkbacks_business_daycare');
  };

  const isAuthenticated = () => {
    return !!token;
  };

  const value = {
    token,
    daycare,
    loading,
    login,
    logout,
    isAuthenticated,
    API_URL,
  };

  return <BusinessAuthContext.Provider value={value}>{children}</BusinessAuthContext.Provider>;
};

export default BusinessAuthContext;
